import { baseFetch } from 'src/utils';

export const createStripeCheckoutSession = async ({
  plan,
  promoCode,
}: {
  plan: 'personal' | 'organization';
  promoCode?: string;
}) => {
  try {
    const res = await baseFetch('/api/subscribe/create-checkout-session', {
      method: 'POST',
      body: JSON.stringify({ subPlan: plan, ...(promoCode && { promoCode }) }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error ? data.error : 'unknown_failure');
    }

    return data;
  } catch (error) {
    throw new Error('unknown_failure');
  }
};
